import config from "../../../config/config.json";
import { headers } from "../../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
  cancelPreviousRequest,
  decryptResponse
} from "../../../APIHelpers/Responses";

export const storeTagServices = {
  addNewStoreTag,
  updatedStoreTag,
  softDeleteRestoreStoreTag,
  deleteStoreTag,
  getStoreTagList,
};

// Add New Store Tag
async function addNewStoreTag(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewStoreTag`,
    headersWithAuth("POST", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Update Store Tag
async function updatedStoreTag(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updatedStoreTag`,
    headersWithAuth("PUT", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Soft Delete & Restore Store Tag
async function softDeleteRestoreStoreTag(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreStoreTag`,
    headersWithAuth("PUT", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Delete Store Tag
async function deleteStoreTag(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteStoreTag`,
    headersWithAuth("DELETE", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Get All Store Tag
async function getStoreTagList(status, search, page, length) {
  try {
    const signal = cancelPreviousRequest(`getStoreTagList`);
    let apiURL;
    if (page && length) {
      apiURL = `${config.API_URL_USER_ONBOARDING}getStoreTagList/${status}?search=${search || ""}&page=${page}&length=${length}`;
    } else {
      apiURL = `${config.API_URL_USER_ONBOARDING}getStoreTagList/${status}?search=${search || ""}`;
    }
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}